import { Form, FormItem, Input } from 'formik-antd';
import { LockOutlined } from '@ant-design/icons';
import { Button, Card, Typography } from 'antd';
import { Formik } from 'formik';
import * as React from 'react';
import styled from 'styled-components';
import { FormikOnSubmit } from 'lib/formik.utils';
import { newPasswordValidationSchema } from 'common/config/validationSchema';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';

const { Title } = Typography;

export interface NewPasswordFormModel {
  oldPassword: string;
  newPassword: string;
  repeatNewPassword: string;
}

export interface NewPasswordFormProps {
  loading: boolean;
  onSubmit: FormikOnSubmit<NewPasswordFormModel>;
}

const StyledCard = styled(Card)`
  width: 400px;
`;

export const NewPasswordForm: React.FC<NewPasswordFormProps> = ({
  onSubmit,
  loading,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik
      initialValues={{
        oldPassword: '',
        newPassword: '',
        repeatNewPassword: '',
      }}
      onSubmit={onSubmit}
      validationSchema={newPasswordValidationSchema(intlMessage)}
    >
      {({ touched }) => (
        <Form>
          <Title>{intlMessage({ id: 'person.password.new' })}</Title>
          <StyledCard>
            <FormItem name="oldPassword">
              <Input
                name="oldPassword"
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder={intlMessage({ id: 'person.password.current' })}
              />
            </FormItem>
            <FormItem name="newPassword">
              <Input
                name="newPassword"
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder={intlMessage({ id: 'person.password.new' })}
              />
              {!touched.newPassword && (
                <FormattedMessage id={'validation.passwordRegex'} />
              )}
            </FormItem>
            <FormItem name="repeatNewPassword">
              <Input
                name="repeatNewPassword"
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder={intlMessage({ id: 'person.password.new' })}
              />
            </FormItem>
            <Button
              id="button-save-new-password"
              htmlType="submit"
              loading={loading}
              style={{ width: '100%', backgroundColor: 'rgb(57, 192, 254)' }}
              type="primary"
            >
              {loading && intlMessage({ id: 'loading' })}
              {!loading && intlMessage({ id: 'save' })}
            </Button>
          </StyledCard>
        </Form>
      )}
    </Formik>
  );
};
